export const leadXChangeLocale = {
  en: {
    subTitle_configuration:
      'Get a comprehensive snapshot of contact interactions, details, and activity history for better engagement insights.',
    dashboard: 'Dashboard',
    configuration: 'Configuration',
    campaign_configuration: 'Campaign Configuration',
    general_configuration: 'General Configuration',
    claimed_leads: 'Claimed Leads',
    overview: 'Overview',
    leads: 'Leads',
    choose_config: 'Choose Config',
    global_system_behaviours: 'Global System Behaviours',
    add_another: 'Add Another',
    commission_type: 'Commission Type',
    entity: 'Entity',
    entity_revenue_share: 'Entity Revenue Share',
    max_claim: 'Max claim/agent, contact',
    select: 'Select',
    commission_type: 'Commission Type',
    value: 'Value',
    add_another: 'Add Another',
    return_closed_leads_to_pools: 'Return Closed Leads to Pools',
    allow_reclaim_by_previous_agent: 'Allow Reclaim by Previous Agent',
    allow_claim_multiple_leads_per_contact:
      'Allow Claim of Multiple Leads per Contact',
    get_a_comprehensive:
      'Get a comprehensive snapshot of contact interactions, details, and activity history for better engagement insights.',
    access_and_claim_high_potential:
      'Access and claim high-potential leads shared across all branches. Use filters to target leads that best match your expertise, track engagement status, and take action in real time to maximize conversions.',
    configure_revenue_sharing:
      'Configure revenue sharing, claim permissions, and system-wide pool behaviors. All changes apply globally across LeadXchange environments.',
    set_custom_commission_rules:
      'Set custom commission rules for specific campaigns by entity. Campaign overrides take priority over default entity settings and help you manage incentive programs more flexibly.',
    set_automatic_return_rules:
      'Set automatic return rules for leads that remain inactive. Fine-tune reassignment limits and inactivity thresholds to maintain healthy lead follow-up and pool efficiency.',
  },
  ar: {
    subTitle_configuration:
      'احصل على نظرة شاملة لتفاعلات جهة الاتصال والتفاصيل وسجل النشاط للحصول على رؤى أفضل للتفاعل.',
    dashboard: 'لوحة التحكم',
    configuration: 'الإعدادات',
    campaign_configuration: 'إعدادات الحملة',
    general_configuration: 'الإعدادات العامة',
    claimed_leads: 'العملاء المتوقعون المطالب بهم',
    overview: 'نظرة عامة',
    leads: 'العملاء المتوقعون',
    choose_config: 'اختر الإعداد',
    global_system_behaviours: 'سلوكيات النظام العامة',
    add_another: 'أضف آخر',
    commission_type: 'نوع العمولة',
    entity: 'الجهة',
    entity_revenue_share: 'نسبة إيرادات الجهة',
    max_claim: 'الحد الأقصى للمطالبة / الوكيل، العميل',
    select: 'اختر',
    commission_type: 'نوع العمولة',
    value: 'القيمة',
    add_another: 'أضف آخر',
    return_closed_leads_to_pools:
      'إرجاع العملاء المحتملين المغلقين إلى المسابح',
    allow_reclaim_by_previous_agent:
      'السماح باسترجاع العميل من قبل الوكيل السابق',
    allow_claim_multiple_leads_per_contact:
      'السماح بالمطالبة بعدة عملاء محتملين لكل جهة اتصال',
    get_a_comprehensive:
      'احصل على لمحة شاملة عن تفاعلات جهات الاتصال والتفاصيل وسجل النشاط للحصول على رؤى أفضل للمشاركة.',
    access_and_claim_high_potential:
      'الوصول إلى العملاء المحتملين ذوي الفرص العالية والمشاركة في جميع الفروع. استخدم الفلاتر لاستهداف العملاء الذين يتناسبون مع خبرتك، وتتبع حالة التفاعل، واتخذ الإجراءات في الوقت الفعلي لزيادة التحويلات.',
    configure_revenue_sharing:
      'تهيئة مشاركة الإيرادات، وأذونات المطالبة، وسلوكيات النظام العامة للمجموعة. يتم تطبيق جميع التغييرات على مستوى بيئة LeadXchange بالكامل.',
    set_custom_commission_rules:
      'قم بتعيين قواعد عمولة مخصصة لحملات معينة حسب الكيان. تأخذ إعدادات الحملة أولوية على إعدادات الكيان الافتراضية وتساعدك على إدارة برامج الحوافز بمرونة أكبر.',
    set_automatic_return_rules:
      'قم بتعيين قواعد الإرجاع التلقائي للعملاء الذين ظلوا غير نشطين. اضبط حدود إعادة التعيين وحدود عدم النشاط للحفاظ على متابعة سليمة للعملاء وكفاءة المجموعة.',
  },
  cn: {
    subTitle_configuration:
      '全面了解联系人的互动、详细信息和活动历史，以获得更深入的参与见解。',
    dashboard: '仪表板',
    configuration: '配置',
    campaign_configuration: '活动配置',
    general_configuration: '通用配置',
    claimed_leads: '已认领的潜在客户',
    overview: '概览',
    leads: '潜在客户',
    choose_config: '选择配置',
    global_system_behaviours: '全局系统行为',
    add_another: '添加另一个',
    commission_type: '佣金类型',
    entity: '实体',
    entity_revenue_share: '实体收入份额',
    max_claim: '每个代理/联系人最大认领数',
    select: '选择',
    commission_type: '佣金类型',
    value: '数值',
    add_another: '添加另一个',
    return_closed_leads_to_pools: '将已关闭的潜在客户返回到池中',
    allow_reclaim_by_previous_agent: '允许前代理重新认领',
    allow_claim_multiple_leads_per_contact: '允许每个联系人认领多个潜在客户',
  },
  ru: {
    subTitle_configuration:
      'Получите полное представление о взаимодействиях с контактами, деталях и истории активности для лучшего понимания вовлеченности.',
    dashboard: 'Панель управления',
    configuration: 'Конфигурация',
    campaign_configuration: 'Конфигурация кампании',
    general_configuration: 'Общие настройки',
    claimed_leads: 'Принятые лиды',
    overview: 'Обзор',
    leads: 'Лиды',
    choose_config: 'Выбрать конфигурацию',
    global_system_behaviours: 'Глобальное поведение системы',
    add_another: 'Добавить еще',
    commission_type: 'Тип комиссии',
    entity: 'Сущность',
    entity_revenue_share: 'Доля дохода сущности',
    max_claim: 'Макс. заявок/агент, контакт',
    select: 'Выбрать',
    commission_type: 'Тип комиссии',
    value: 'Значение',
    add_another: 'Добавить еще',
    return_closed_leads_to_pools: 'Возврат закрытых лидов в пулы',
    allow_reclaim_by_previous_agent:
      'Разрешить повторное получение предыдущим агентом',
    allow_claim_multiple_leads_per_contact:
      'Разрешить несколько заявок на одного контакта',
  },
};

export const leadXChangeLocalePath = 'leadXChangeView';
